<template>


  <div class="wrapper">

    <v-sidebar activeNavItem="asset"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'Assets'" v-bind:path="'/asset'"></v-navbar>

      <form @submit.prevent="beforeSubmit">
        <div class="content">
            <div class="container-fluid">
              <div class="row">
                <TractorForm v-if="type === 'tractor'" ref="form" v-bind:title="'Edit Tractor'"></TractorForm>
                <TrailerForm v-if="type === 'trailer'" ref="form" v-bind:title="'Edit Trailer'"></TrailerForm>
              </div>
              <div class="row">
                <div class="col-12 text-right">

                  <p v-for="error in validationErrors" class="help is-danger">{{ error.msg }}</p>


                  <button class="btn btn-simple btn-link btn-wd" v-on:click="cancel()"><i class="fa fa-times"></i> Cancel</button>
                  <button type="submit" class="btn btn-success btn-wd"><i class="fa fa-save"></i> Save</button>
                </div>
              </div>
            </div>
        </div>
      </form>

      <v-footer></v-footer>

    </div>

  </div>


</template>

<script>
import Vue from 'vue'

import router from '../../router'
import apiService from '../../services/api.service'
import config from '../../config'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
import TractorForm from './TractorForm'
import TrailerForm from './TrailerForm'

import { httpPost, httpPut, checkResponseErrors, httpGet } from '../../utils/http'

export default {
  name: 'TractorEdit',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
    'TractorForm': TractorForm,
    'TrailerForm': TrailerForm,
  },
  data: () => ({
    loadData: null,
    validationErrors: [],
    type: null
  }),
  async mounted () {
    $(document).ready(function() {
      $('input').attr('autocomplete', 'new-password');
    });
    this.type = this.$route.params.type;
    if(this.type !== "tractor" && this.type !== "trailer") {
      this.toList();
      return;
    }

    try {
      const resp = await apiService.get('/kong/api/v1/asset/id/' + this.$route.params.id);
      const body = resp.data;
      this.$refs.form.loadData(body.Result);
    } catch (error) {
      Vue.toasted.error(error.message, { duration: 3500 });
      this.cancel();
      return;
    }
  }, // end mounted
  methods: {
    cancel: () => router.push("/asset/view"),
    addErrors: function(srcErrors) {
      if(srcErrors && srcErrors.count() > 0) this.validationErrors = this.validationErrors.concat(srcErrors.items);
    },
    beforeSubmit: async function() {
      this.validationErrors = [];
      this.serverError = null;
      
      const promises = this.$children.map(child => {
        if(!child || !child.$validator) return;
        return child.$validator.validateAll().then(() => this.addErrors(child.errors));
      });
      promises.push(this.$validator.validateAll());
      await Promise.all(promises);
      this.addErrors(this.errors);
      
      if(this.validationErrors.length) return;

      await this.submit();
    },
    submit: async function() {
      try {
        const asset = this.$refs.form.getClearData();
        asset.id = this.$route.params.id;
        const response = await apiService.put('/kong/api/v1/asset/', asset);
        if(await checkResponseErrors(response)) return;
      } catch (error) {
        Vue.toasted.error(error, { duration: 3500 });
        return;
      }

      router.push('/asset/view')
      Vue.toasted.success("Successfully Updated Asset", { duration: 3500 })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssetEdit.vue?7c3c4859